// Generated from SVG to Code Figma Plugin

export const BaseLineConvention = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.5 8H15.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M8.5 12H11.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path
      d="M16.5487 14.9457C16.7299 14.5661 17.2701 14.5661 17.4513 14.9457L18.3232 16.773C18.3961 16.9257 18.5413 17.0313 18.7091 17.0534L20.7164 17.318C21.1334 17.3729 21.3003 17.8868 20.9953 18.1763L19.5269 19.5703C19.4042 19.6868 19.3487 19.8575 19.3795 20.0239L19.7481 22.0148C19.8247 22.4283 19.3876 22.7459 19.018 22.5453L17.2385 21.5794C17.0898 21.4987 16.9102 21.4987 16.7615 21.5794L14.982 22.5453C14.6124 22.7459 14.1753 22.4283 14.2519 22.0148L14.6205 20.0239C14.6513 19.8575 14.5958 19.6868 14.4731 19.5703L13.0047 18.1763C12.6997 17.8868 12.8666 17.3729 13.2836 17.318L15.2909 17.0534C15.4587 17.0313 15.6039 16.9257 15.6768 16.773L16.5487 14.9457Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.3"
    />
    <path
      d="M11 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15V9C4 6.17157 4 4.75736 4.87868 3.87868C5.75736 3 7.17157 3 10 3H14C16.8284 3 18.2426 3 19.1213 3.87868C20 4.75736 20 6.17157 20 9V13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </svg>
);
